<template>
  <div> 
          <WorkflowApplyDetail
      ref="WorkflowApplyDetail">
    </WorkflowApplyDetail>
      <table style="width:90%">
          <tr><td> <div style="float:left"><h1>{{translateWords.CRKRecord}}</h1></div></td></tr>
            <tr><td> <el-input  v-model="spmc"  :placeholder="translateWords.inputName"></el-input></td><td> <el-input  v-model="spbm"  :placeholder="translateWords.inputspbm"></el-input></td><td> <el-button type="primary" @click="query">{{translateWords.query}}</el-button></td></tr> 
  <tr><td style="padding:10px;" > <el-input  v-model="czr"  :placeholder="translateWords.operator"></el-input></td><td style="padding:10px;" >  <el-date-picker
      v-model="qssj"
    type="date"
                  format="yyyy-MM-dd"
      :placeholder="translateWords.startTime">
    </el-date-picker></td><td style="padding:10px;" >  
        <el-date-picker
      v-model="jssj"
     type="date"
                  format="yyyy-MM-dd"
      :placeholder="translateWords.endTime">
    </el-date-picker></td></tr> 
   </table>
     
      <el-table
      :data="tableData"
      style="width:100%">   
      <el-table-column 
        prop="Id"
        :label="translateWords.code" width=100
   >
       </el-table-column>
            <el-table-column
        prop="ProductName"
        :label="translateWords.productName" width=200
    >
           
    </el-table-column>   
            <el-table-column width=200
        prop="ProductCode"
        :label="translateWords.ProductCode"
    >
 
      </el-table-column> 
            <!-- <el-table-column width=200
        prop="SupplierCode"
        :label="translateWords.SupplierCode"  
    >
     
      </el-table-column>  -->
      
             <el-table-column width=200
        prop="OpType"
        :label="translateWords.OpType"
    >
     
      </el-table-column> 
  <el-table-column width=100
        prop="SumCount"
        :label="translateWords.SumCount"
    >
    
      </el-table-column> 
 <el-table-column width=200
        prop="CreateName"
        :label="translateWords.CreateName"
    > 
     
      </el-table-column> 
  <el-table-column width=200
        prop="CreateTime" 
         :formatter="dateFormat" 
        :label="translateWords.CreateTime"
    >
    </el-table-column> 
    <el-table-column width=200
        :label="translateWords.ApplyID"
    > 
     	<template slot-scope="scope">
         
   <el-button @click="openworkflow(scope.row.ApplyID)"  type="text" size="small">{{scope.row.ApplyID?scope.row.ApplyID:''}}</el-button>
	</template>

      </el-table-column> 
    </el-table>
     <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10,20,30]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
   
  </div>
</template>

<script>
  import {importScript} from '../util/importScript'
  import WorkflowApplyDetail from "@/components/WorkflowApplyDetail";
  export default {
    name: 'RKRecord',
     components: {
      WorkflowApplyDetail
  },
    data() {
      return {
        translateWords : { 
          inputName:"请输入商品名称", 
          operator:"操作人", 
          startTime:"起始时间" ,
          endTime:"结束时间" ,
          code:"编码", 
          productName:"产品名称",
          ProductCode:"产品条码",
          SupplierCode:"供应商代码",
          OpType:"类型", 
          SumCount:"数量", 
          CreateName:"操作人" ,
          CreateTime:"操作时间",
          CRKRecord:"出入库记录",
          inputspbm:'请输入商品条码',
          query:'查询',
          ApplyID:'审批单'
        },
        spmc:'',
        spbm:'',
        qssj:'',
        jssj:'',
        czr:'',
        total: 0,
        currPage: 1,
        pageSize: 10,
        isQuery: false,
        tableData:[],
         uid: this.$route.query.uid,
      token: this.$route.query.token,
      lang: this.$route.query.lang
     
      }
    },
    created:function(){
       this.getData(1, this.pageSize);
    },
    mounted(){ 
        var that = this; 
        importScript(this.baseurl,() => {   
          that.translateWord();
        }); 
    },
    methods:{
       openworkflow:function (applyid){
           var _this=this;
           _this.$refs.WorkflowApplyDetail.ShowWorkflowApply(applyid,_this.baseurl,_this.lang,_this.token);
        },
          translateWord(){
            var that = this; 
            if(window.jsT){  
              this.translateWords = {
                inputName: window.jsT.T(that.translateWords.inputName),
                operator: window.jsT.T(that.translateWords.operator),
                startTime: window.jsT.T(that.translateWords.startTime), 
                endTime: window.jsT.T(that.translateWords.endTime),
                code: window.jsT.T(that.translateWords.code),
                productName: window.jsT.T(that.translateWords.productName), 
                ProductCode: window.jsT.T(that.translateWords.ProductCode),
                SupplierCode: window.jsT.T(that.translateWords.SupplierCode),
                OpType: window.jsT.T(that.translateWords.OpType), 
                SumCount: window.jsT.T(that.translateWords.SumCount),
                CreateName: window.jsT.T(that.translateWords.CreateName),
                CreateTime: window.jsT.T(that.translateWords.CreateTime),
                CRKRecord: window.jsT.T(that.translateWords.CRKRecord),
                inputspbm: window.jsT.T(that.translateWords.inputspbm),
                query:window.jsT.T(that.translateWords.query),
                ApplyID:window.jsT.T(that.translateWords.ApplyID)
              };
            console.log(this.translateWords)
               
            }
            else{
              console.log("翻译组件加载失败")
            } 
          },
          query()
           {
               this.isQuery=true;
               this.getData(1, 10);
           },   
           init()
           {
        this.spmc='',
        this.spbm='',
        this.qssj='',
        this.jssj='',
        this.czr=''
           } ,
            getData(index, size) {
                         var params = new URLSearchParams()
                         params.append("pageIndex", index);
                         params.append("pageSize", size);
                           params.append("uid", this.uid);
                              params.append("lang", this.lang);
                         params.append("cmd", "LoadSample_OutInWarehouseRecord");
                         if (this.isQuery) {
                             params.append("spmc", this.spmc);
                             params.append("spbm", this.spbm);
                             params.append("czr", this.czr);  
                               if ((this.qssj != "") && (this.qssj != null)) {
                                 var currentqssj = new Date(this.qssj).toJSON().split('T')[0];
                                 params.append("qssj", currentqssj);
                             }
                             else {
                                 params.append("qssj", "");
                             }
                         if ((this.jssj != "")&& (this.jssj != null)) {
                                 var currentjssj = new Date(this.jssj).toJSON().split('T')[0];
                                 params.append("jssj", currentjssj);
                             }
                             else {
                                 params.append("jssj", "");
                             }
                         }                   
                         this.$http.post(this.actionurl, params)
                             .then(res => {
                                 this.tableData = res.data.Data.list;
                                 this.total = res.data.Data.total;
                         })
            }, 
            
    dateFormat:function(row,column){
          var date = row[column.property]; 
          if (date === undefined) { 
            return ""; 
          } 
          var moment = require("moment");
          return moment(date).format("YYYY-MM-DD HH:mm:ss"); 
    },      
              handleSizeChange(val) {              
                         this.pageSize = val;
                         this.currPage = 1;
                         this.getData(this.currPage, this.pageSize);
                     },
                     handleCurrentChange(val) {
                         this.currPage = val;
                         this.getData(this.currPage, this.pageSize);
                     } 
          }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RKRecord.vue